/* global angular */
angular.module('bzConstantsModule', [])
